import { useSelector } from "react-redux"
import { useMutation, useQuery } from "@tanstack/react-query"

import { API_BANKS_URL } from "../constants"
import { IBankMeta } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

async function fetchDefaultBankByCustomerId(
  token: string | null,
  customerId: string,
) {
  const response = await axios(`${API_BANKS_URL}/${customerId}/default`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка получения информации о банке")
  }
  return response.data
}

const formatPhoneToFetch = (phoneNumber: string) => {
  const cleaned = phoneNumber.replace(/\D/g, "")
  return cleaned
}

async function fetchDefaultBankByPhone(
  token: string | null,
  phoneNumber: string | undefined,
) {
  const formatPhone = formatPhoneToFetch(phoneNumber as string)
  const response = await fetch(
    `${API_BANKS_URL}/byPhone/default?Phone=${formatPhone}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  if (!response.ok) {
    throw new Error("Ошибка получения информации о банке")
  }

  if (!response.ok) {
    return null
  }

  return response.json()
}

export const useDefaultBankByCustomerId = (customerId: string) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IBankMeta>({
    queryKey: ["default-bank-by-customerid", customerId],
    queryFn: () => fetchDefaultBankByCustomerId(token, customerId),
    enabled: Boolean(token),
  })
}

export const useDefaultBankByPhoneNumber = (
  phoneNumber: string | undefined,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IBankMeta>({
    queryKey: ["default-bank-by-phone", phoneNumber],
    queryFn: () => fetchDefaultBankByPhone(token, phoneNumber),
    enabled: Boolean(token) && Boolean(phoneNumber),
  })
}

export const useGetDefaultBankByPhoneNumber = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<IBankMeta, unknown, string | undefined>({
    mutationFn: (req) => fetchDefaultBankByPhone(token, req),
  })
}
